import { ChatSessionsData } from 'core_main/api/sessions/types';
import { ConversationCallbackResponse } from '../types';

export const createEndConversationCallbackResponse = (
  data: ChatSessionsData,
): ConversationCallbackResponse => {
  const { id: conversationId } = data;
  const { createdAt, lockedAt } = data.attributes;
  return {
    conversationId,
    createdAt,
    ended: !!lockedAt,
  };
};
